module.exports = __webpack_public_path__ + "img/caribbeansunset-min.44902b21.png";